import { FormattedMessage } from 'react-intl';
import ScheduleSectionBlock from './ScheduleSectionBlock';

export default function ScheduleListEmptyState() {
  return (
    <div className="p-4">
      <div className="rounded-xl border border-slate-200/80 bg-white/70 p-3">
        <ScheduleSectionBlock>
          <div className="py-2 text-center text-slate-500">
            <FormattedMessage id="schedule.list.empty" />
          </div>
        </ScheduleSectionBlock>
      </div>
    </div>
  );
}
